import config from '@/config';
import useCache from '@/hooks/useCache';
import useTranslations from '@/i18n/useTranslations';
import Loader from "@/shared-components/loader/Loader";
import ActivityHeading from '@/shared-components/text/components/ActivityHeading';
import Text from '@/shared-components/text/components/Text';
import { filterRenderablePosts } from '@/utils/activityContent';

import VirtualList from './components/VirtualList';

import './index.css';

export default function LikedArticles() {
  const t = useTranslations('common.profile.activity');
  const { loading, fetchData, loadMoreData } = useCache(
    'liked_articles',
    `${config.apis.api.url}/posts/liked`,
    {
      injectToken: true,
      invalidateWhen: ['LIKE_POST'],
      includeSearchQueries: {
        content: 'articles',
      },
    }
  );
  const safeFetchData = fetchData ?? { data: [], totalDocs: 0 };
  const articles = filterRenderablePosts(safeFetchData.data);

  const page = {
    ...safeFetchData,
    data: articles,
    totalDocs: typeof safeFetchData.totalDocs === 'number' ? safeFetchData.totalDocs : articles.length
  };

  return (
    <>
      <ActivityHeading text={t('menu.liked_articles')} />
      <div className="activity-liked-articles__container">
        {loading ? (
          <Loader className="activity-liked-articles__spinner" />
        ) : articles.length === 0 ? (
          <Text className="activity-liked-articles__text font-size-medium">
            {t('empty.liked_articles')}
          </Text>
        ) : (
          <VirtualList items={page} onLoadMore={loadMoreData} />
        )}
      </div>
    </>
  );
}
